import { clsx } from 'clsx';
import { useCallback } from 'react';
import type { CalendarState } from 'react-stately';
import { spacing } from '../../../../styles/spacing.css';
import { Flex } from '../../../Flex/Flex';
import { Icon } from '../../../Icon/Icon';
import { Layout } from '../../../Layout/Layout';
import { Text } from '../../../Text/Text';
import { CalendarView } from '../types';
import * as styles from './CalendarHeader.css';
import { NavigationButton } from './NavigationButton';

interface CalendarHeaderProps {
  readonly title: string;
  readonly daysView: boolean;
  readonly state: CalendarState;
  readonly isPrevDisabled?: boolean;
  readonly isNextDisabled?: boolean;
  readonly setCalendarView: (step: CalendarView) => void;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  title,
  daysView,
  isPrevDisabled,
  isNextDisabled,
  state,
  setCalendarView,
}) => {
  const updateCalendarView = useCallback((): void => {
    setCalendarView(daysView ? CalendarView.Year : CalendarView.Day);
  }, [daysView, setCalendarView]);

  return (
    <Layout p={{ md: spacing.s16 }} paddingBlockEnd={0} paddingBlockStart={{ md: 0, lg: spacing.s16 }}>
      <Flex justifyContent="space-between">
        <Flex
          alignItems="center"
          as="button"
          className={styles.monthTitle}
          cursor="pointer"
          gap={spacing.s08}
          onClick={updateCalendarView}
          padding={spacing.s08}
          type="button"
        >
          <Text type="h5">{title}</Text>
          <Icon className={clsx(styles.arrowIcon, { [styles.arrowIconOpen]: !daysView })} name="dropdown" size="sm" />
        </Flex>

        {daysView && (
          <Flex alignItems="center" gap={spacing.s04}>
            <NavigationButton direction="back" isDisabled={isPrevDisabled} onClick={() => state.focusPreviousPage()} />
            <NavigationButton direction="next" isDisabled={isNextDisabled} onClick={() => state.focusNextPage()} />
          </Flex>
        )}
      </Flex>
    </Layout>
  );
};
